// extracted by mini-css-extract-plugin
export var aiButton = "ai-button-module--aiButton--0ef7f";
export var aiChatIcon = "ai-button-module--aiChatIcon--8ea86";